const Easings = {
  easeInOutCub: "0.65, 0, 0.35, 1",
  easeOutCub: "0.33, 1, 0.68, 1",
  easeInCub: "0.32, 0, 0.67, 0",
  back: "0.2, 0.9, 0.3, 1.2",
};

export default Easings
